/*!
 * DH Commerce OS v1.4
 * dh-commerce-ui.js
 *
 * UI Layer
 * Purpose:
 * - Connect DHCommerce engines to the DOM.
 * - No business logic.
 * - No storefront assumptions.
 * - Event-driven bindings only.
 */

(function (window, document) {
  "use strict";

  window.DHCommerce = window.DHCommerce || {};

  const UI = {
    version: "1.4.0",
    initialized: false,

    init() {
      if (this.initialized) return;
      this.bindEvents();
      this.initialized = true;
    },

    bindEvents() {
      document.addEventListener("recommendation-ready", this.onRecommendations);
      document.addEventListener("offer-updated", this.onOffers);
      document.addEventListener("personalization-updated", this.onProfile);
    },

    onRecommendations(event) {
      // Config/bootstrap decides what to render.
      console.debug("Recommendations ready", event.detail);
    },

    onOffers(event) {
      console.debug("Offers updated", event.detail);
    },

    onProfile(event) {
      console.debug("Profile updated", event.detail);
    },

    destroy() {
      document.removeEventListener("recommendation-ready", this.onRecommendations);
      document.removeEventListener("offer-updated", this.onOffers);
      document.removeEventListener("personalization-updated", this.onProfile);
      this.initialized = false;
    }
  };

  window.DHCommerce.ui = UI;

})(window, document);